import { useCallback } from 'react';
import { useList, useCreate, useDelete } from '@refinedev/core';

import { ATTACKIQ_ID } from '@attackiq/constants/platform';

import { TaggedItem } from '../types';

interface UseTaggedItemsProps {
  objectId: string;
  contentType: number | string;
}

export function useTaggedItems({ objectId, contentType }: UseTaggedItemsProps) {
  const {
    result: data,

    query: { refetch, isLoading }
  } = useList<TaggedItem>({
    resource: 'tagged_items',
    filters: [
      { field: 'object_id', operator: 'eq', value: objectId },
      { field: 'content_type', operator: 'eq', value: contentType }
    ],
    pagination: { pageSize: 1000 }
  });

  const { mutateAsync: createTaggedItem } = useCreate();
  const addTag = useCallback(
    async (tagId: string) => {
      try {
        await createTaggedItem({
          resource: 'tagged_items',
          values: {
            tag: tagId,
            content_type: contentType,
            object_id: objectId,
            company: ATTACKIQ_ID
          }
        });
      } finally {
        refetch();
      }
    },
    [createTaggedItem, objectId, contentType, refetch]
  );

  const { mutateAsync: deleteTaggedItem } = useDelete();
  const removeTag = useCallback(
    async (taggedItemId: string) => {
      await deleteTaggedItem({
        resource: 'tagged_items',
        id: taggedItemId
      });
      refetch();
    },
    [deleteTaggedItem, refetch]
  );

  return {
    taggedItems: data?.data ?? [],
    isLoading,
    addTag,
    removeTag,
    refetch
  };
}
